<template>
    <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
        width="16"
        height="16"
    >
        <path d="M13.5 4.5a3.9 3.9 0 0 1 5.5 5.5L8 20l-5.5 1.5L4 15.5z"></path>
        <path d="M12 6l5.5 5.5"></path>
    </svg>
</template>
